import axios from 'axios';
import environment from '../config/environment';
const token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NDI4Njg4NTEsImV4cCI6MzE3Mjg3MzExMjUxfQ.2mE_QrkNic7VtOrtuDyddHL4cvRzdWIE9NKqTEpnYgg";

const apiClient = axios.create({
  baseURL: environment.nodeApiUrl, 
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, 
});


export const etokenApi = axios.create({
  baseURL: environment.etokenApiUrl, 
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});


etokenApi.interceptors.request.use(config => {
 // console.log('Request URL:', config.baseURL + config.url);
  return config;
});

etokenApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export default apiClient;